import { render, staticRenderFns } from "./HeaderEmilia.vue?vue&type=template&id=ca57918a&scoped=true&"
import script from "./HeaderEmilia.vue?vue&type=script&lang=js&"
export * from "./HeaderEmilia.vue?vue&type=script&lang=js&"
import style0 from "./HeaderEmilia.vue?vue&type=style&index=0&id=ca57918a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca57918a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VContainer,VImg,VNavigationDrawer})
